import pixelDb from "@/pixels/pixelDb";
import * as MUTATIONS from "../../config/constants/mutation-types";

describe("pixelDb config", () => {
  it("Debe contener triggers para la mutations ON_ROUTE", () => {
    const expectedTriggers = {
      [MUTATIONS.ON_ROUTE]: {
        landing: [],
        paso1: ["Facebook.paso1", "Google.paso1", "Adobe.paso1"],
        gracias: ["Facebook.gracias", "Google.gracias", "Adobe.thank"],
        mensaje: ["Facebook.mensaje", "Google.mensaje", "Adobe.mensaje"]
      }
    };

    expect(pixelDb.triggers[MUTATIONS.ON_ROUTE]).toEqual(
      expectedTriggers[MUTATIONS.ON_ROUTE]
    );
  });

  it("Debe contener triggers para la mutations ON_ADOBE_APPSTARTED", () => {
    const expectedTriggers = {
      [MUTATIONS.ON_ADOBE_APPSTARTED]: ["Adobe.clickTracking"]
    };

    expect(pixelDb.triggers[MUTATIONS.ON_ADOBE_APPSTARTED]).toEqual(
      expectedTriggers[MUTATIONS.ON_ADOBE_APPSTARTED]
    );
  });
});
